<app-form-min-zone></app-form-min-zone>
<div class="d-flex">
  <div class="col-12 my-1">
    <button id="create-variable" class="btn btn-indigo float-right" type="submit" (click)="create()">
      <span>
        Ajouter une Zone
      </span>
    </button>
  </div>
</div>
<div class="basic-container" style="margin-top: 10px;">
  <table mat-table [dataSource]="lstZones" multiTemplateDataRows class=" mat-elevation-z8">
    <!-- Nom -->
    <ng-container matColumnDef="label">
      <th mat-header-cell *matHeaderCellDef> Label </th>

      <td mat-cell *matCellDef="let element">
      <span >
          {{element.label}}
      </span>
    </td>
    </ng-container>
    <!-- Identifiant -->
    <ng-container matColumnDef="NbrPlace">
      <th mat-header-cell *matHeaderCellDef> Nbr de place </th>
      <td mat-cell *matCellDef="let element"> {{element.places?element.places.length:0}} </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Actif </th>
      <td mat-cell *matCellDef="let element">
          <section class="example-section">
            <mat-slide-toggle
                class="example-margin" (change)="activateZone(element,$event)"
                [checked]="element.active" >
            </mat-slide-toggle>
          </section>
      </td>
    </ng-container>
    <!-- Actions -->
    <ng-container matColumnDef="Actions">
      <th mat-header-cell *matHeaderCellDef> </th>
      <td mat-cell *matCellDef="let element">
        <div class="buttons">
          <ng-container *ngIf="this.authenSer.isAdmin">
            <div class="m-2">
              <span (click)="editDisplay(element)">
                <i class="fa fa-pencil-square-o text-primary" style="cursor: pointer;" aria-hidden="true"
                  title="Editer"></i>
              </span>
            </div>
            <div class="m-2">
              <span (click)="openDeleteConfirm(element.id)">
                <i class="fa fa-trash-o text-danger" style="cursor: pointer;" aria-hidden="true" title="Supprimer"></i>
              </span>
            </div>
          </ng-container>
          <ng-container *ngIf="this.authenSer.isAdmin">
            <div class="m-2">
              <span (click)="editDisplay(element)">
                <i class="fa fa-pencil-square-o text-primary" style="cursor: pointer;" aria-hidden="true"
                  title="Editer"></i>
              </span>
            </div>
          </ng-container>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row "
      [class.example-expanded-row]="expandedElement === element"
      (click)="expandedElement = expandedElement === element ? null : element">
    </tr>
  </table>
</div>
